/**
 * Re-export du StorageManager partage (@shared).
 * Conserve authStorage pour les methodes specifiques au module auth
 * (user data, nettoyage complet auth).
 */

export { StorageManager, storage } from '@shared/infrastructure/storage';
import { storage } from '@shared/infrastructure/storage';
import { tokenStorage } from '@shared/infrastructure/storage';

/**
 * Helpers specifiques a l'authentification.
 * Les methodes token deleguent au tokenStorage partage.
 * Les methodes user restent locales au module auth.
 */
export const authStorage = {
  setAccessToken(token: string): boolean {
    return tokenStorage.setAccessToken(token);
  },

  getAccessToken(): string | null {
    return tokenStorage.getAccessToken();
  },

  clearTokens(): void {
    tokenStorage.clearTokens();
  },

  setUser(user: unknown): boolean {
    return storage.setItem('caritas_user', user);
  },

  getUser<T = unknown>(): T | null {
    return storage.getItem<T>('caritas_user');
  },

  clearUser(): void {
    storage.removeItem('caritas_user');
  },

  clearAll(): void {
    this.clearTokens();
    this.clearUser();
  },
};
